import { render, staticRenderFns } from "./ActivityView.vue?vue&type=template&id=f8f2a892&scoped=true"
import script from "./ActivityView.vue?vue&type=script&lang=js"
export * from "./ActivityView.vue?vue&type=script&lang=js"
import style0 from "./ActivityView.vue?vue&type=style&index=0&id=f8f2a892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f2a892",
  null
  
)

export default component.exports